<script lang="ts">
  import { getContext } from "svelte"
  import { DefaultWidgetsCssSelectors } from "website_script/constants/DefaultCssSelectors"
  import {
    getCustomerCarUrls,
    ParsedWidget,
    parsePriceRatingWidgetElementsForSelector,
  } from "website_script/lib/Parsers"
  import type { Settings } from "website_script/types/settings"
  import PriceRatingWidget from "../components/PriceRatingWidget.svelte"
  import PriceRatingWidgetCollection from "../components/PriceRatingWidgetCollection.svelte"
  import { autouncleBrandTheme } from "lib/constants"
  import InlineWidget from "website_script/components/InlineWidget.svelte"
  import { trackFunction } from "website_script/lib/tracking"

  const {
    selectorToAppendPriceRatingWidget,
    selectorToIdenfityCarUrl: carUrlSelector,
    selectorToIdenfityCarItem: carItemSelector,
    priceRatingWidgetCar,
  } = getContext<Settings>("settings")

  const parseOptions =
    carUrlSelector && carItemSelector
      ? { carUrlSelector, carItemSelector }
      : undefined

  const selector =
    selectorToAppendPriceRatingWidget ??
    DefaultWidgetsCssSelectors.priceRatingWidget

  let priceRatingsWidgetCollections: ParsedWidget[][] = []
  // Stores the price rating widgets that have already been parsed
  const parsedWidgetsMap = new Map<HTMLElement, ParsedWidget>()

  const parseWidgets = () => {
    const parsedWidgets = parsePriceRatingWidgetElementsForSelector(
      selector,
      parseOptions
    )
    const newParsedWidgets: ParsedWidget[] = []
    parsedWidgets.forEach((widget) => {
      const existingParsedWidget = parsedWidgetsMap.get(widget.elTarget)
      if (!existingParsedWidget) {
        parsedWidgetsMap.set(widget.elTarget, widget)
        newParsedWidgets.push(widget)
      }
    })
    if (newParsedWidgets.length === 0) return

    priceRatingsWidgetCollections = [
      ...priceRatingsWidgetCollections,
      newParsedWidgets,
    ]
  }

  parseWidgets()

  if (parsedWidgetsMap.size > 0 && priceRatingWidgetCar !== null) {
    trackFunction({
      entity: "price_rating_widget",
      action: "displayed",
      type: "displayed_cta",
      details: `1 car with rating ${priceRatingWidgetCar.car.auRating}`,
    })
  }
</script>

<svelte:window on:auwsUpdateInlineWidgets={parseWidgets} />
{#each priceRatingsWidgetCollections as widgets, i (widgets[0]?.elTarget || i)}
  {#if priceRatingWidgetCar !== null}
    {#each widgets as widget}
      <InlineWidget target={widget.elTarget} theme={autouncleBrandTheme}>
        <PriceRatingWidget car={priceRatingWidgetCar.car} />
      </InlineWidget>
    {/each}
  {:else}
    <PriceRatingWidgetCollection urls={getCustomerCarUrls(widgets)} {widgets} />
  {/if}
{/each}
